import React from "react";
import { string, shape, object } from "prop-types";
import { BrandColoredCard } from "./BrandColoredCard";
import { CategoryCard } from "./CategoryCard";
import { useCategoryLandingLogic } from "./categorylogic";
import { Pagination } from "../../atoms/Pagination";
import LoadingIndicatorComponent from "../../atoms/loading-indicator";

import "./category-landing-page.m.css";

const CategoryLandingPage = (props) => {
  const {
    collection,
    stories,
    totalStories,
    totalPages,
    currentPage,
    currentPageStories,
    cardsPerRow,
    hideImages,
    handlePageChange,
    getStoryCount,
    chunkStories,
    isMobile,
    mounted,
    isLoadingMetadata,
    isAuthInitializing,
  } = useCategoryLandingLogic(props);

  if (isAuthInitializing || isLoadingMetadata) return <LoadingIndicatorComponent />;

  if (!mounted) return null;


  return (
    <div className="container category-page-container">
      <div styleName="category-landing-page">
        {!isMobile() && (
          <div styleName="header-section">
            <h1 styleName="page-title">{getStoryCount()}</h1>
          </div>
        )}

        <div styleName="story-grid-container">
          <div styleName="default-card">
            <BrandColoredCard collection={collection} firstStory={stories[0]} />
            {currentPageStories.slice(0, cardsPerRow - 1).map((story) => (
              <CategoryCard
                key={story.id}
                story={story}
                hideImage={hideImages}
              />
            ))}
          </div>

          {isMobile() && (
            <div styleName="header-section">
              <h1 styleName="page-title">{getStoryCount()}</h1>
            </div>
          )}

          {chunkStories(currentPageStories.slice(cardsPerRow - 1), cardsPerRow).map(
            (chunk, index) => (
              <div key={index} styleName="default-card">
                {chunk.map((story) => (
                  <CategoryCard
                    key={story.id}
                    story={story}
                    hideImage={hideImages}
                  />
                ))}
              </div>
            )
          )}
        </div>

        {totalPages > 1 && (
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            noTopMargin={true}
          />
        )}
      </div>
    </div>
  );
};

CategoryLandingPage.propTypes = {
  pageType: string,
  data: shape({
    collection: object,
  }),
};

export { CategoryLandingPage };
